import { register } from '@shopify/theme-sections';
import Swiper from "swiper";

register('vertical-gallery', {
  
  _findCurrentSwiper(swiperId) {
    if (this.swipers.length) {
      return this.swipers.find(swiper => swiper.wrapperEl.dataset.swiperId === this.id);
    }
    return this.swipers
  },
  
  _slideToBlock: function (index) {
    this._findCurrentSwiper().slideTo(index);
  },
  
  initPromoCarousel() {
    let slideHeight;
    let galleryBlock = $(this.container).find(".vertical-gallery__block");
    slideHeight = $(galleryBlock).outerHeight();
    $('.vertical-gallery--height').css({
      maxHeight: slideHeight,
    });
    $(window).resize(function() {
      slideHeight = $(galleryBlock).outerHeight();
      console.log('slideHeight', slideHeight)
      $(this.container).find('.vertical-gallery--height').css({
        maxHeight: slideHeight,
      });
    })
    this.swipers = new Swiper('.vertical-gallery', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      spaceBetween: 20,
      watchOverflow: true,
      loop: true,
      speed: 800,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // scrollbar: {
      //   el: '.swiper-scrollbar',
      //   hide: false,
      // },
      breakpoints: {
        1200: {
          direction: 'vertical',
          spaceBetween: 20,
        },
      },
    });
  },
  
  initFramesLogic() {
    const section = $(this.container).find('.vertical-gallery__img');
  
    $(section).on('click', (e) => {
      this._slideToBlock((+e.target.closest('.swiper-slide').dataset.index + 1));
    })
  },
  
  // Shortcut function called when a section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
  onLoad: function (e) {
    this.initPromoCarousel();
    this.initFramesLogic();
  },
  
  // Shortcut function called when a section is selected by the Theme Editor 'shopify:section:select' event.
  onSelect: function () {
    // Do something when a section instance is selected
  },
  
  // Shortcut function called when a section unloaded by the Theme Editor 'shopify:section:unload' event.
  onUnload: function (e) {
    this._findCurrentSwiper().destroy();
    // Do something when a section instance is unloaded
  },
  
  // Shortcut function called when a section is deselected by the Theme Editor 'shopify:section:deselect' event.
  onDeselect: function () {
    this._findCurrentSwiper().slideTo(0);
    // Do something when a section instance is deselected
  },
  
  // Shortcut function called when a section block is selected by the Theme Editor 'shopify:block:select' event.
  onBlockSelect: function (e) {
    this._slideToBlock(e.target.dataset.index)
    // Do something when a section block is selected
  },
  
  // Shortcut function called when a section block is deselected by the Theme Editor 'shopify:block:deselect' event.
  onBlockDeselect: function (e) {
    this._findCurrentSwiper().slideTo(0);
    // Do something when a section block is deselected
  }
  
})
